import { Injectable } from '@angular/core';
import { AnomalieResponse, UsersWithAnomaliesResponse, AnomalyTypeResponse, AnomalyLevelsResponse, Anomalia, User, BaseResponse, DetailAnomlieResponse } from "../core/core.component";
import { Http, Headers, URLSearchParams } from '@angular/http';
import { AppConstants } from '../core/app.constants';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { environment } from 'environments/environment';

@Injectable()
export class AnomalieService {
  private anomalieComponentStatus = new Subject<User>();
  anomalieComponentStatus$ = this.anomalieComponentStatus.asObservable();

  constructor(private http: Http) { }

  getAnomalieByUser(srmToken, filterUserId: number): Observable<AnomalieResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/anomalies";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    let params: URLSearchParams = new URLSearchParams();
    if (filterUserId == null || filterUserId <= 0) {
      filterUserId = 0;
    }

    params.set('userID', filterUserId.toString());
    return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
  }

  getAnomalieForAllUser(srmToken): Observable<AnomalieResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/anomalies/allForUsers";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
  }

  getAnomalieForCurrentUser(srmToken): Observable<AnomalieResponse> {
    return this.getAnomalieByUser(srmToken, 0);
  }

  getAnomalyTypes(srmToken): Observable<AnomalyTypeResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/anomalies/types";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
  }

  getAnomalyLevels(srmToken): Observable<AnomalyLevelsResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/anomalies/levels";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
  }

  getAnomalieUserStatus(srmToken: string, userID?: number): Observable<DetailAnomlieResponse> {
      var url = environment.REST_SERVICE_BASE_URL + "/anomalies/getUserAnomaliesConfig";
      var headers = new Headers();
      headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
      headers.append('Content-Type', 'application/json');
      let params: URLSearchParams = new URLSearchParams();
      params.set('userID', userID.toString());

      return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
  }

  updateAnomalieUtenteStatus(srmToken: string, id?: number, displayLevel?: boolean[], blockingLevel?: boolean[]): Observable<BaseResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/anomalies/updateUserAnomalieConfig";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    let body = {
      id: id,
      displayLevel: displayLevel || [],
      blockingLevel: blockingLevel || []
    };

    return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
  }

  getAnomalieComponentStatus(): Observable<User> {
    return this.anomalieComponentStatus.asObservable();
  }

  openAnomalieComponent(user: User) {
    this.anomalieComponentStatus.next(user);
  }

  closeAnomalieComponent() {
    this.anomalieComponentStatus.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/anomalie.service.ts